import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';

import { Carousel } from 'react-responsive-carousel';
import { CuratedPageType } from 'pages/curated-pages/types';
import { CURATED_FOR_YOU } from 'modules/utils/constants';
import { PageReferenceProps } from 'components/Cta/types';
import CuratedPagesItem from './CuratedPagesItem';
import Skeleton from './Skeleton';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './styles.module.scss';
import { InformationCard } from 'components/CMSModals/informationcard';

export type Publication = {
  cta: { label: string; custom_url: string; page_link: PageReferenceProps[] };
  custom_url: string;
  image: { url: string };
  preview_description: string;
  preview_title: string;
  price: string;
};

type CuratedPagesProp = {
  curatedPages?: CuratedPageType[];
  curatedCMSPages?: InformationCard[];
  loaded: boolean;
};

const CuratedPages: React.FunctionComponent<CuratedPagesProp> = ({
  curatedPages,
  curatedCMSPages,
  loaded,
}) => {
  const isMobile = useMediaQuery({
    query: `(max-width: 1152px) and (min-width: 768px), (max-width: 520px)`,
  });

  const getCuratedPages = useCallback(
    () =>
      curatedCMSPages &&
      curatedCMSPages.map((curatedPage: any, index: number) => (
        <CuratedPagesItem
          curatedCMSPages={curatedPage}
          key={`curated-page-card-${index}`}
        />
      )),
    [curatedCMSPages],
  );

  return loaded ? (
    <React.Fragment>
      {curatedCMSPages && (
        <section className={styles.curatedPages}>
          <h2>{CURATED_FOR_YOU}</h2>
          <div>
            {isMobile && curatedCMSPages.length > 1 ? (
              <Carousel
                emulateTouch={true}
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                  return (
                    <li
                      aria-label={`${label} ${index + 1}`}
                      className={clsx('dot', isSelected && 'selected')}
                      key={index}
                      onClick={onClickHandler}
                      onKeyDown={onClickHandler}
                      tabIndex={-1}
                    ></li>
                  );
                }}
                showArrows={false}
                showStatus={false}
                showThumbs={false}
                swipeScrollTolerance={20}
              >
                {getCuratedPages()}
              </Carousel>
            ) : (
              <React.Fragment>{getCuratedPages()}</React.Fragment>
            )}
          </div>
        </section>
      )}
    </React.Fragment>
  ) : (
    <Skeleton />
  );
};

export default CuratedPages;
